/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { noticeClientControllerFindByIdV1 } from '../fn/notice-client/notice-client-controller-find-by-id-v-1';
import { NoticeClientControllerFindByIdV1$Params } from '../fn/notice-client/notice-client-controller-find-by-id-v-1';
import { noticeClientControllerSearchV1 } from '../fn/notice-client/notice-client-controller-search-v-1';
import { NoticeClientControllerSearchV1$Params } from '../fn/notice-client/notice-client-controller-search-v-1';
import { NoticeDto } from '../models/notice-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class NoticeClientService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `noticeClientControllerSearchV1()` */
  static readonly NoticeClientControllerSearchV1Path = '/api/v1/notices/client';

  /**
   * 공지사항 목록 조회 (클라이언트).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeClientControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeClientControllerSearchV1$Response(params: NoticeClientControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<NoticeDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = noticeClientControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 목록 조회 (클라이언트).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeClientControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeClientControllerSearchV1(params: NoticeClientControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<NoticeDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.noticeClientControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<NoticeDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<NoticeDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `noticeClientControllerFindByIdV1()` */
  static readonly NoticeClientControllerFindByIdV1Path = '/api/v1/notices/client/{id}';

  /**
   * 공지사항 상세 조회 (클라이언트).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeClientControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeClientControllerFindByIdV1$Response(params: NoticeClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
    const obs = noticeClientControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 상세 조회 (클라이언트).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeClientControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeClientControllerFindByIdV1(params: NoticeClientControllerFindByIdV1$Params, context?: HttpContext): Observable<NoticeDto> {
    const resp = this.noticeClientControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<NoticeDto>): NoticeDto => r.body)
    );
  }

}
